export function contact($) {

    var nlform = new NLForm( document.getElementById( 'nl-form' ) );

    $('body').on('click', '.contact--form .nl-field ul li', function() {
      $('#nl-form input, #nl-form select').trigger('change');
    });

}
